import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import { useTranslation } from "react-i18next";
import { Menu, X } from "lucide-react";
import { motion } from "framer-motion";
import logo from "../assets/logo.png";

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const navLinks = [
    { name: t('home'), to: "Home" },
    { name: t('about'), to: "About" },
    { name: t('services'), to: "Services" },
    { name: t('department'), to: "Department" },
    { name: t('contact'), to: "Contact" },
     { name: t('jobs'), to: "Jobs" },
  ];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  // Shrink Navbar on Scroll
  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ease-in-out ${
        scrolled
          ? "bg-gradient-to-r from-blue-500 via-sky-400 to-cyan-400"
          : "bg-gradient-to-r from-blue-600 via-purple-600 to-pink-700 py-4 shadow-lg"
      }`}
    >
      <div className="max-w-7xl mx-auto flex justify-between items-center px-4">
        {/* Logo */}
        <motion.div
          whileHover={{ scale: 1.05 }}
          className="flex items-center space-x-2 cursor-pointer"
        >
          <img
            src={logo}
            alt="Natraj Hospital Logo"
            className={`object-cover rounded-full transition-all duration-300 ${
              scrolled ? "h-10 w-10" : "h-14 w-14"
            }`}
          />
          <h1
            className={`text-white font-bold transition-all duration-300 ${
              scrolled ? "text-xl" : "text-2xl"
            }`}
          >
            Natraj Hospital
          </h1>
        </motion.div>

        {/* Desktop Menu */}
        <nav className="hidden md:flex items-center space-x-8">
          {navLinks.map((link, index) => (
            <Link
              key={index}
              to={link.to}
              smooth={true}
              duration={600}
              offset={-80}
              className="text-white font-semibold hover:text-yellow-300 transition-all cursor-pointer"
            >
              {link.name}
            </Link>
          ))}

          {/* Language Toggle */}
          <div className="flex space-x-2 ml-6">
            <button
              onClick={() => changeLanguage('en')}
              className="text-white bg-blue-500 px-2 py-1 rounded-md hover:bg-blue-700 text-sm"
            >
              EN
            </button>
            <button
              onClick={() => changeLanguage('hi')}
              className="text-white bg-green-500 px-2 py-1 rounded-md hover:bg-green-700 text-sm"
            >
              हिंदी
            </button>
          </div>
        </nav>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <X className="text-white h-8 w-8" /> : <Menu className="text-white h-8 w-8" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-blue-700">
          <nav className="flex flex-col items-center py-4 space-y-4">
            {navLinks.map((link, index) => (
              <Link
                key={index}
                to={link.to}
                smooth={true}
                duration={600}
                offset={-80}
                onClick={() => setIsOpen(false)}
                className="text-white font-semibold hover:text-yellow-300 transition-all cursor-pointer"
              >
                {link.name}
              </Link>
            ))}
            {/* Language Toggle */}
            <div className="flex space-x-2 mt-4">
              <button
                onClick={() => changeLanguage('en')}
                className="text-white bg-blue-500 px-2 py-1 rounded-md hover:bg-blue-700 text-sm"
              >
                EN
              </button>
              <button
                onClick={() => changeLanguage('hi')}
                className="text-white bg-green-500 px-2 py-1 rounded-md hover:bg-green-700 text-sm"
              >
                हिंदी
              </button>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Navbar;
